import Vue from "vue";
import Axios from "axios";
import { eventBus } from "../main";
// import { ErrorLogService } from "./../servicesTs/models/general/errorLog";

let url = window.location.hostname;
url = url.split("");
if (url[url.length - 1] == "w") {
  Axios.defaults.baseURL = `${process.env.VUE_APP_API_URL_LOCAL}/api`;
} else if (url[url.length - 1] == "m") {
  Axios.defaults.baseURL = `${process.env.VUE_APP_API_URL_SSM}/api`;
} else {
  Axios.defaults.baseURL = `${process.env.VUE_APP_API_URL}/api`;
}
Axios.defaults.headers.common.Accept = "application/json";

// const axios = require('axios').create({
//   baseURL: process.env.VUE_APP_API_URL
// });

Axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      // store.dispatch('auth/logout');
      eventBus.$emit("value", true);
    }
    let title = "";
    let message = "";
    if (error.response) {
      if (error.response.data) {
        title = error.response.data.exception;
        message = `CODE: ${error.response.status}\n EXCEPTION: ${error.response.data.exception}\n FILE: ${error.response.data.file}`;
      } else {
        title = error.response.statusText;
        message = `CODE: ${error.response.status}\n MESSAGE: ${error.response.statusText}`;
      }
    }
    // if (JSON.parse(window.localStorage.getItem("user"))?.id) {
    //   ErrorLogService.create({
    //     id: 0,
    //     user_id: JSON.parse(window.localStorage.getItem("user"))?.id,
    //     role_id: Number(window.localStorage.getItem("role_id")),
    //     node_id: Number(window.localStorage.getItem("stablishment")),
    //     error_message: message,
    //     error_title: title,
    //     url: window.location.href,
    //     browser: navigator.userAgent,
    //     error_type: "axios",
    //   });
    // }
    return Promise.reject(error);
  }
);

Axios.interceptors.request.use(
  (request, config) => {
    const token = `Bearer ${window.localStorage.getItem("token")}`;
    if (token) {
      request.headers.Authorization = token;
    }
    return request;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Bind Axios to Vue.
Vue.$http2 = Axios;
Object.defineProperty(Vue.prototype, "$http2", {
  get() {
    return Axios;
  },
});
